function getSize(mbSize: number): string {
  if (mbSize >= 1024) return `${(mbSize / 1024).toFixed(1)} GB`;
  return `${mbSize} MB`;
}

export default getSize;
